import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=40cd7eb0"
import script from "./activate.component.ts?vue&type=script&lang=ts&external"
export * from "./activate.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports